/** Discharge authorization is an explicit choice in this note, never enriched content. */
export const isDischargeActionField = (field) => field?.type === 'checkbox' && field.systemAction === 'discharge_case';

export function updateNoteField(field, key, value) {
  const updated = { ...field, [key]: value };
  if (updated.type !== 'checkbox') delete updated.systemAction;
  if (updated.type !== 'date_composite') delete updated.dateConstraint;
  if (isDischargeActionField(updated)) {
    for (const property of ['defaultValue', 'carryForward', 'formPopulation', 'prefill', 'variableBinding', 'aiField', 'prompt']) {
      delete updated[property];
    }
  }
  return updated;
}
